var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000101821132086261181620000010755771334006560150_);}\r\n\t.st1{fill:#0E497A;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2.5,
    y: 5.9,
    width: 25,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101076867514572374120000016002215206096062120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101076867514572374120000016002215206096062120_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,14.3c-1.7,0-2.2-1.9-2.2-2.9c0-1.5,1.2-2.1,2.2-2.1s2.2,0.5,2.2,2.1C13.8,12.4,13.4,14.3,11.6,14.3z  M11.6,9.9c-0.4,0-1.6,0.1-1.6,1.5c0,0.8,0.3,2.3,1.6,2.3s1.6-1.5,1.6-2.3C13.2,10,12,9.9,11.6,9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,18.7h-1.5c-2.9,0-3.4-0.6-3.4-2.2c0-1.1,0.6-2.1,1.6-2.8c0.1-0.1,0.3-0.1,0.4,0.1 c0.1,0.1,0.1,0.3-0.1,0.4c-0.9,0.6-1.4,1.4-1.4,2.3c0,1.1,0,1.6,2.8,1.6h1.5c2.8,0,2.8-0.5,2.8-1.6c0-0.9-0.5-1.7-1.4-2.3 c-0.1-0.1-0.2-0.3-0.1-0.4c0.1-0.1,0.3-0.2,0.4-0.1c1,0.7,1.6,1.7,1.6,2.8C15.7,18.1,15.2,18.7,12.4,18.7L12.4,18.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,24.1H5.6c-1.7,0-3.1-1.4-3.1-3.1V9c0-1.7,1.4-3.1,3.1-3.1h12.1c1.7,0,3.1,1.4,3.1,3.1V21 C20.8,22.7,19.4,24.1,17.7,24.1z M5.6,7.3C4.7,7.3,4,8.1,4,9V21c0,0.9,0.7,1.6,1.6,1.6h12.1c0.9,0,1.6-0.7,1.6-1.6V9 c0-0.9-0.7-1.6-1.6-1.6L5.6,7.3L5.6,7.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,24.1c-0.4,0-0.7-0.3-0.7-0.7V6.6c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v16.8 C24.1,23.8,23.8,24.1,23.4,24.1L23.4,24.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,24.1c-0.4,0-0.7-0.3-0.7-0.7V6.6c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v16.8 C27.5,23.8,27.2,24.1,26.8,24.1L26.8,24.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrail);
export default __webpack_public_path__ + "static/media/AuditTrail.419df8eabb7ccfc560b756f1180509e8.svg";
export { ForwardRef as ReactComponent };